import React from 'react';
import { withTrans } from "@i18n/withTrans";

import { Etics } from './Etics';
import { Grammar } from './Grammar';
import { Roles } from './Roles';
import { Stages } from './Stages';
import { WritingAbout } from './WritingAbout';
import { WritingGoals } from './WritingGoals';
import { FlexDiv, Page } from '@Main/elements';
import { PageNavigation, Margin } from '@helpers';

import { useStaticQuery, graphql } from "gatsby"

const Content = ({t, i18n}) => {
    i18n.loadNamespaces('content');

    const pages = [
        {
            title: 'Writing goals',
            component: WritingGoals,
        },
        {
            title: 'Content ethics',
            component: Etics,
        },
        {
            title: 'Grammar and checkup',
            component: Grammar,
        },
        {
            title: 'Writing about Soft-FX products and solutions',
            component: WritingAbout,
        },
        {
            title: 'Content production stages and checkup',
            component: Stages,
        },
        {
            title: 'Roles and responsibilities',
            component: Roles,
        },
    ];

    const data = useStaticQuery(graphql`
        {
            images: allFile(filter: {relativeDirectory: {eq: "content"}, extension: {eq: "png"}}) {
                edges {
                    node {
                        childImageSharp {
                            gatsbyImageData(width: 800, placeholder: DOMINANT_COLOR, formats: NO_CHANGE)
                        }
                        name
                        publicURL
                        relativePath,
                        extension
                    }
                }
            },
            zips: allFile(filter: {relativeDirectory: {eq: "content"}, extension: {eq: "zip"}}) {
                edges {
                    node {
                        name
                        publicURL
                        relativePath,
                        extension
                    }
                }
            }
        }
    `)

    const getPng = (fileName) => {
        const file = data.images.edges.filter(edge => edge.node.name === fileName)[0];

        return file.node;
    }

    const getZip = (fileName) => {
        const file = data.zips.edges.filter(edge => edge.node.name === fileName)[0];

        return file.node.publicURL;
    }

    return (
        <Page>
            <PageNavigation t={t} onThisPage={pages.map(page => t(`content>${page.title}`))}/>
            <FlexDiv direction="column">
                { 
                    pages.map((page, index) => 
                        <Margin id={`block-${index + 1}`} key={page.title} marginTop={index && '50px'}>
                            {
                                React.createElement(page.component, {
                                        key: index,
                                        getPng: getPng,
                                        getZip: getZip,
                                        t: (text) => t(`content>${text}`)
                                })
                            }
                        </Margin>
                    )
                }
            </FlexDiv>
        </Page>
    );
};

export const ContentContainer = withTrans(Content)